import React from 'react';
import { LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

type TestProgressProps = {
    passed: number;
    total: number;
    completeText?: React.ReactNode;
    style?: React.CSSProperties;
};

// styled()'s injected custom prop ("complete") isn't part of LinearProgress's
// own prop types, so this errors without relaxing the generic - matches the
// styled(X)<any>(...) pattern used elsewhere in this migration.
const StyledLinearProgress = styled(LinearProgress)<any>(({ complete }: any) => ({
    ...(complete && {
        backgroundColor: '#448044',
        '& .MuiLinearProgress-bar': {
            backgroundColor: '#448044 !important'
        }
    })
}));

const TestProgress = (props: TestProgressProps) => {
    const { passed, total, completeText, style } = props;
    var progress = (passed/total) * 100;

    return (<div style={{display: 'flex', flexDirection: 'row', height: '100%', ...style}}>
    <div style={{display: 'flex', flexDirection: 'column', flex: '1 1 auto', position: 'relative'}}>
    <StyledLinearProgress complete={progress === 100 ? 1 : 0} variant='determinate' value={progress} style={{flex: '1 1 auto'}}/>
    <div style={{display: progress === 100 ? 'flex' : 'none', fontWeight: 'bold', color: 'white', position: 'absolute', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}}>{completeText}</div>
    </div>
    <div style={{marginLeft: '1em', alignSelf: 'center', width: '5em'}}>{passed} / {total}</div>
    </div>);
};

export default TestProgress;
